import React from 'react'
import PropTypes from 'prop-types'

import VideoPlayer from 'agency/digital_renderer/components/VideoPlayer'

import ContentHolder from '../../ui/ContentHolder'
import styles from './styles.scss'

const Welcome = ({ campaignProposal }) => {
  const { cover_letter, options } = campaignProposal
  const hasVideo = options && options.video_provider && options.video_id

  if (!cover_letter && !hasVideo) return null

  return (
    <div className={styles.root}>
      <ContentHolder>
        {hasVideo && (
          <div className={styles.video}>
            <VideoPlayer dataSource={campaignProposal} />
          </div>
        )}

        <h2>Welcome</h2>

        <p>{cover_letter}</p>
      </ContentHolder>
    </div>
  )
}

Welcome.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
}

export default Welcome
